import { Klass, u_ } from "@pressmedia/webappbase";
import "@pressmedia/tyrellmodule";

/**
 * データ取得用モジュールのセッター
 *
 * @param {*} module
 * @returns this
 */
function setModule(module) {
	if( !( module instanceof Klass("TyrellModule") ) ) {
		(module === this.module) && (delete this.module);
		throw new TypeError("arguments[0] must be instance of TyrellModule Klass.");
	}
	
	this.module = module;
	
	if( !u_.hasProperty(module, "vuw") ) {
		module.vuw = this;
		module.initList = ( (...args) => this.initList(...args) );
		this.onReady($self => module.$areaList = $self);
	}
	
	if( !u_.hasProperty(module, "loadConfig") ) {
		// override `loadConfig`
		module.loadConfig = async (reqData, callback) => {
			if( !u_.isObject(reqData) ) {
				u_.isFunction(reqData) && (callback = reqData);
				reqData = undefined;
			}
			
			return Klass(module.klass).prototype.loadConfig.call(
				module,
				reqData,
				async (err, res) => {
					if(!err && module.config.pageLimit && !this.infinite) {
						const more = module.config.pageLimit - this.getReplicants().length;
						(more > 0) && await this.addReplicants(more).catch(e => err = {
							code: NaN,
							messages: [e],
							method: "loadConfig"
						});
					}
					
					return !u_.isFunction(callback) || callback(err, res);
				}
			);
		};
	}
	
	return this;
}

export default setModule;
